import http from '@services/http';
import { Recruitments } from '$admin/api/interfaces';

export const importExtractedLinkedInProfile = (data: Recruitments.ImportExtractedLinkedInProfile.Request): Promise<Recruitments.ImportExtractedLinkedInProfile.Response> => {
  const { profileId, ...rest } = data;

  return http.put(`/admin/recruitments/linkedin/profiles/${profileId}/import`, rest);
};

export * as dashboard from './recruitments.dashboard';